import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import StyledLoadingButton from "../../providers/theme/design-tokens/LoadingButton/StyledLoadingButton";

type UnsavedChangesConfirmProps = {
  open: boolean;
  title?: string;
  description?: string;
  onDiscard: () => void;
  onCancel: () => void;
  onSave: () => void;
  onSaveLoading: boolean;
};

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  padding: theme.spacing(2),
  height: 40,
  whiteSpace: "nowrap",
}));

const UnsavedChangesConfirm: React.FC<UnsavedChangesConfirmProps> = ({
  open,
  title = "You have unsaved changes",
  description = "You have unsaved changes in this sidebar. What would you like to do?",
  onDiscard,
  onCancel,
  onSave,
  onSaveLoading,
}) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          minWidth: "600px",
          borderRadius: "12px",
          p: 1,
        },
      }}
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        sx={{ m: 0, p: 2, textAlign: "center", position: "relative" }}
      >
        <Typography variant="h4">{title}</Typography>
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ textAlign: "center", color: "text.secondary" }}>
          {description}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{ display: "flex", justifyContent: "space-between", gap: 1, p: 2 }}
      >
        <StyledButton variant="outlined" color="error" onClick={onDiscard}>
          Discard changes
        </StyledButton>

        <Box sx={{ display: "flex", gap: 1 }}>
          <StyledButton variant="outlined" onClick={onCancel}>
            Cancel
          </StyledButton>

          <StyledLoadingButton
            variant={onSaveLoading ? "outlined" : "contained"}
            onClick={onSave}
            loading={onSaveLoading}
          >
            Save changes
          </StyledLoadingButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesConfirm;
